export default {
    title: 'Trees',
    'placeholder': 'Trees Planted',
   
    'content1': `List of some trees planted in Vale Florido for the Projeto Mil Folhas:`,
    'content2': `(Page refers to the book Brazilian Trees Vol 1 and 2, H. Lorenzi/Plantarum)`,
    'content3': `https://www.plantarum.com.br/prod,idcategoria,206630,livros-em-ingles`,
    'content4': `Brazilian Trees Vol 1 and 2`,
    
    'table1': `Trees with PRIMARY characteristics, according to climate, altitude, and soil in the region:`,
    'col1': `Popular Name`,
    'col2': `Scientific Name`,
    'col3': `Family`,
    'col4': `Page`,
    'table2': `Trees with EARLY SECONDARY characteristics, according to climate, altitude, and soil in the region:`,
    'table3': `Trees with LATE SECONDARY characteristics, according to climate, altitude, and soil in the region:`,
    'table4': `Trees with CLIMAX characteristics, according to climate, altitude, and soil in the region:`


   
  };